<div class="pt-5 px-10 pb-10">
  <div class="flex justify-between items-start mb-4">
    <div class="flex flex-col gap-1">
      <span class="text-lg font-bold text-gray-800">Consultores > Visualizar Consultor</span>
      <app-voltar-indicator (navigateBack)="navigateBack()"></app-voltar-indicator>
    </div>
    <button
      *ngxPermissionsOnly="['Permissions.Consultants.ResendCredentials']"
      type="button"
      class="bg-primary text-white py-2 px-4 rounded-lg flex items-center disabled:opacity-50 disabled:cursor-not-allowed"
      (click)="confirmResetPassword()"
      [disabled]="isResettingPassword || !consultant?.hasEmail"
    >
      {{ isResettingPassword ? 'Enviando...' : 'Reenviar Senha de Acesso' }}
    </button>
  </div>

  <div *ngIf="isLoading" class="flex justify-center items-center h-64">
    <mat-spinner [diameter]="40"></mat-spinner>
  </div>

  <div *ngIf="!isLoading && consultant" class="flex flex-col gap-6">
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <div class="flex flex-col gap-6">
        <div class="bg-white rounded-lg shadow p-6">
          <h2 class="text-lg font-semibold mb-4 text-gray-800">Informações do Consultor</h2>
          <div class="flex gap-6">
            <div class="flex flex-col items-center gap-2">
              <div class="relative">
                <img
                  [src]="consultant.avatarUrl || 'assets/img/default-consultant-avatar.png'"
                  alt="Avatar"
                  class="w-24 h-24 rounded-full object-cover border border-gray-200"
                  onerror="this.src='assets/img/default-consultant-avatar.png'"
                />
              </div>
              <app-badge [variant]="consultant.isOnline ? 'green' : 'gray'">
                {{ consultant.isOnline ? 'Em Atividade' : 'Offline' }}
              </app-badge>
            </div>

            <div class="flex-1 grid grid-cols-1 xl:grid-cols-2 gap-4 min-w-0">
              <div class="min-w-0">
                <label class="text-xs text-gray-500 block">Nome Completo</label>
                <span class="text-sm font-medium text-gray-800 block">{{ consultant.nome | capitalizeWords }}</span>
              </div>
              <div class="min-w-0">
                <label class="text-xs text-gray-500 block">E-mail</label>
                <span class="text-sm font-medium text-gray-800 block truncate" [title]="consultant.email">{{ consultant.email || '-' }}</span>
              </div>
              <div class="min-w-0">
                <label class="text-xs text-gray-500 block">Telefones de Contato</label>
                <span class="text-sm font-medium text-gray-800 block">{{ formatPhones() }}</span>
              </div>
              <div class="min-w-0">
                <label class="text-xs text-gray-500 block">Grupos de Rotas Atribuídos</label>
                <div class="flex flex-wrap gap-2 mt-1">
                  <ng-container *ngIf="consultant.routeGroups.length > 0; else noRouteGroups">
                    <app-badge *ngFor="let group of consultant.routeGroups" variant="blue">
                      {{ group }}
                    </app-badge>
                  </ng-container>
                  <ng-template #noRouteGroups>
                    <span class="text-sm text-gray-400">Nenhum ciclo ativo</span>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="bg-white rounded-lg shadow p-6 flex-1 flex flex-col">
          <h2 class="text-lg font-semibold mb-4 text-gray-800">Pendências do Consultor</h2>
          <ng-container *ngIf="pendingItems.length > 0; else noPendencias">
            <div class="flex flex-col gap-3 flex-1 overflow-y-auto pendencias-list">
              <div
                *ngFor="let pendencia of pendingItems"
                class="border border-gray-200 rounded-lg p-4"
              >
                <div class="flex justify-between items-start">
                  <div class="flex flex-col gap-1">
                    <span class="text-sm font-medium text-gray-800">{{ formatDateBr(pendencia.date) }}</span>
                    <span class="text-xs text-gray-500">Rota: {{ pendencia.title }}</span>
                    <div class="flex gap-4 mt-1">
                      <span class="text-xs text-green-600">Check-in: {{ pendencia.startedAt ? (pendencia.startedAt | date:'HH:mm') : '-' }}</span>
                      <span class="text-xs text-red-600">Check-out: {{ pendencia.completedAt ? (pendencia.completedAt | date:'HH:mm') : '-' }}</span>
                    </div>
                  </div>
                  <span class="text-sm font-medium text-red-600">{{ pendencia.pendingStopCount }} {{ pendencia.pendingStopCount === 1 ? 'pendência' : 'pendências' }}</span>
                </div>
              </div>
              <div class="flex justify-end">
                <div class="flex items-center gap-1 cursor-pointer text-primary hover:underline">
                  <span class="text-sm font-medium">Ver Mais</span>
                  <mat-icon class="text-base">chevron_right</mat-icon>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-template #noPendencias>
            <div class="flex items-center justify-center flex-1">
              <span class="text-sm text-gray-400">Nenhuma pendência encontrada</span>
            </div>
          </ng-template>
        </div>
      </div>

      <div class="bg-white rounded-lg shadow p-6 flex flex-col">
        <h2 class="text-lg font-semibold mb-4 text-gray-800">Em Tempo Real</h2>
        <div class="flex flex-col gap-4 flex-1">
          <ng-container *ngIf="consultantToday; else noTodayRoute">
            <div class="border border-gray-200 rounded-lg p-4 flex flex-col gap-1">
              <span class="text-sm font-medium text-gray-800">{{ todayDateFormatted }}</span>
              <span class="text-xs text-gray-500">Rota: {{ consultantToday.routeName || consultantToday.cycleName }}</span>
              <div class="flex gap-4">
                <span class="text-xs text-gray-500">Check-in: {{ consultantToday.startedAt ? (consultantToday.startedAt | date:'HH:mm') : '-' }}</span>
                <span class="text-xs text-gray-500">Check-out: {{ consultantToday.completedAt ? (consultantToday.completedAt | date:'HH:mm') : '-' }}</span>
              </div>
              <span *ngIf="consultantToday.currentStop" class="text-xs text-pink-600">
                Loja Atual: {{ consultantToday.currentStop.storeName }} ({{ consultantToday.currentStop.checkInAt | date:'HH:mm' }}{{ consultantToday.currentStop.checkOutAt ? ' - ' + (consultantToday.currentStop.checkOutAt | date:'HH:mm') : '' }})
              </span>
            </div>
          </ng-container>
          <ng-template #noTodayRoute>
            <div class="flex items-center gap-3 p-4 border border-gray-200 rounded-lg bg-gray-50">
              <mat-icon class="text-gray-400">event_busy</mat-icon>
              <div class="flex flex-col">
                <span class="text-sm font-medium text-gray-500">Nenhuma rota atribuída hoje</span>
                <span class="text-xs text-gray-400">{{ todayDateFormatted }}</span>
              </div>
            </div>
          </ng-template>

          <div class="map-container relative flex-1">
            <ng-container *ngIf="mapMarkers().length > 0; else noLocation">
              <app-google-map [markers]="mapMarkers()" />
            </ng-container>
            <ng-template #noLocation>
              <div class="empty-map-placeholder">
                <mat-icon class="empty-map-icon">location_off</mat-icon>
                <span class="text-sm font-medium text-gray-500">Localização não disponível</span>
                <span class="text-xs text-gray-400">A localização será exibida quando o consultor estiver em atividade</span>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-4">
      <h2 class="text-lg font-semibold text-gray-800">Rotas a Realizar (Programadas)</h2>

      <app-search-filter-bar
        searchPlaceholder="Buscar rotas..."
        [filters]="rotasProgramadasFilters"
        (filterChange)="onRotasProgramadasFilterChange($event)"
      ></app-search-filter-bar>

      <div class="bg-white rounded-lg shadow overflow-hidden">
        <ngx-datatable
          class="material"
          [rows]="scheduledDays"
          [columnMode]="ColumnMode.flex"
          [headerHeight]="50"
          [footerHeight]="50"
          [rowHeight]="'auto'"
          [externalPaging]="true"
          [count]="totalScheduledDays"
          [offset]="scheduledDaysPage"
          [limit]="scheduledDaysPageSize"
          (page)="onScheduledDaysPageChange($event)"
        >
          <ngx-datatable-column name="Data" prop="date" [flexGrow]="2">
            <ng-template let-value="value" ngx-datatable-cell-template>
              <span class="text-sm text-gray-500">{{ formatDateBr(value) }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Título" prop="title" [flexGrow]="3">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div class="flex flex-col">
                <span class="text-sm text-gray-500">{{ row.title }}</span>
                <span class="text-xs text-gray-400">{{ row.cycleName }}</span>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Lojas" prop="storeCount" [flexGrow]="1">
            <ng-template let-value="value" ngx-datatable-cell-template>
              <span class="text-sm text-gray-500">{{ value ?? '-' }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-footer>
            <ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-curPage="curPage">
              <div class="flex items-center justify-between w-full px-4">
                <span class="text-sm text-gray-500">Mostrando {{ scheduledDaysStart }} a {{ scheduledDaysEnd }} de {{ totalScheduledDays }} resultados</span>
                <datatable-pager
                  [pagerLeftArrowIcon]="'datatable-icon-left'"
                  [pagerRightArrowIcon]="'datatable-icon-right'"
                  [pagerPreviousIcon]="'datatable-icon-prev'"
                  [pagerNextIcon]="'datatable-icon-skip'"
                  [page]="curPage"
                  [size]="pageSize"
                  [count]="rowCount"
                  (change)="onScheduledDaysPageChange({ offset: $event.page - 1 })"
                >
                </datatable-pager>
              </div>
            </ng-template>
          </ngx-datatable-footer>
        </ngx-datatable>
      </div>
    </div>

    <div class="flex flex-col gap-4">
      <h2 class="text-lg font-semibold text-gray-800">Rotas Realizadas</h2>

      <app-search-filter-bar
        searchPlaceholder="Buscar rotas..."
        [filters]="rotasRealizadasFilters"
        (filterChange)="onRotasRealizadasFilterChange($event)"
      ></app-search-filter-bar>

      <div class="bg-white rounded-lg shadow overflow-hidden">
        <ngx-datatable
          class="material"
          [rows]="completedDays"
          [columnMode]="ColumnMode.flex"
          [headerHeight]="50"
          [footerHeight]="50"
          [rowHeight]="'auto'"
          [externalPaging]="true"
          [count]="totalCompletedDays"
          [offset]="completedDaysPage"
          [limit]="completedDaysPageSize"
          (page)="onCompletedDaysPageChange($event)"
        >
          <ngx-datatable-column name="Data" prop="date" [flexGrow]="2">
            <ng-template let-value="value" ngx-datatable-cell-template>
              <span class="text-sm text-gray-500">{{ value }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Título" prop="title" [flexGrow]="2">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div class="flex flex-col">
                <span class="text-sm text-gray-500">{{ row.title }}</span>
                <span class="text-xs text-gray-400">{{ row.cycleName }}</span>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Lojas-Alvo" prop="totalStores" [flexGrow]="1">
            <ng-template let-value="value" ngx-datatable-cell-template>
              <span class="text-sm text-gray-500">{{ value }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Lojas Visitadas" prop="visitedStores" [flexGrow]="1">
            <ng-template let-value="value" ngx-datatable-cell-template>
              <span class="text-sm text-gray-500">{{ value }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-footer>
            <ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-curPage="curPage">
              <div class="flex items-center justify-between w-full px-4">
                <span class="text-sm text-gray-500">Mostrando {{ completedDaysStart }} a {{ completedDaysEnd }} de {{ totalCompletedDays }} resultados</span>
                <datatable-pager
                  [pagerLeftArrowIcon]="'datatable-icon-left'"
                  [pagerRightArrowIcon]="'datatable-icon-right'"
                  [pagerPreviousIcon]="'datatable-icon-prev'"
                  [pagerNextIcon]="'datatable-icon-skip'"
                  [page]="curPage"
                  [size]="pageSize"
                  [count]="rowCount"
                  (change)="onCompletedDaysPageChange({ offset: $event.page - 1 })"
                >
                </datatable-pager>
              </div>
            </ng-template>
          </ngx-datatable-footer>
        </ngx-datatable>
      </div>
    </div>
  </div>

  <div class="h-24"></div>
</div>
